import useAddGenre from "api/GenreResource/useAddGenre";
import { TextField } from "components";
import { Form, Formik } from "formik";
import { Sidebar } from "primereact/sidebar";
import React from "react";
import { FcProcess } from "react-icons/fc";
import { FiPlus } from "react-icons/fi";
import * as Yup from "yup";

const AddGenre = () => {
	const [display, setDisplay] = React.useState(false);

	const initialValues = {
		name: "",
	};

	const validationSchema = Yup.object().shape({
		name: Yup.string().required("Collection name is required"),
	});

	const { mutateAsync, isLoading: isAddingGenre } = useAddGenre();
	const handleSubmit = async (data) => {
		await mutateAsync(data);
		setDisplay(false);
	};

	return (
		<>
			<button
				type="button"
				onClick={() => setDisplay(true)}
				className="group relative inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-gradient-to-r from-akgreen to-akgreenest rounded-lg hover:from-akgreenest hover:to-akgreen transition-all duration-200 shadow-sm hover:shadow-md"
			>
				<span className="relative z-10">Add Collection</span>
				<FiPlus className="relative z-10 transition-transform group-hover:rotate-90 duration-200" />
				<div className="absolute inset-0 bg-white/10 opacity-0 group-hover:opacity-100 transition-opacity rounded-lg" />
			</button>

			<Sidebar
				position="right"
				visible={display}
				onHide={() => setDisplay(false)}
				className="w-[400px]"
				header={
					<div className="flex items-center justify-between border-b border-gray-100 pb-4">
						<h2 className="text-xl font-medium text-gray-800">
							Add New Collection
						</h2>
						<button
							onClick={() => setDisplay(false)}
							className="text-gray-400 hover:text-gray-600 transition-colors"
						>
							<FiPlus
								className="rotate-45"
								size={24}
							/>
						</button>
					</div>
				}
			>
				<div className="p-4">
					<Formik
						initialValues={initialValues}
						validationSchema={validationSchema}
						onSubmit={(data) => handleSubmit(data)}
					>
						{(formik) => {
							return (
								<Form className="space-y-6">
									<div>
										<TextField
											type="text"
											name="name"
											placeholder="e.g Fantasy, Mystery, Romance"
											label="Collection Name"
											inputClasses="w-full p-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-akgreen focus:border-akgreen outline-none transition-all"
										/>
										<p className="mt-2 text-sm text-gray-500">
											Enter a descriptive name for your book collection
										</p>
									</div>

									<div className="flex justify-end gap-3 pt-4 border-t border-gray-100">
										<button
											type="button"
											onClick={() => setDisplay(false)}
											className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
										>
											Cancel
										</button>
										<button
											type="submit"
											disabled={isAddingGenre}
											className="relative inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-gradient-to-r from-akgreen to-akgreenest rounded-lg hover:from-akgreenest hover:to-akgreen transition-all duration-200 disabled:opacity-70 disabled:cursor-not-allowed"
										>
											<span>Create Collection</span>
											{isAddingGenre && (
												<FcProcess
													size={18}
													className="animate-spin"
												/>
											)}
										</button>
									</div>
								</Form>
							);
						}}
					</Formik>
				</div>
			</Sidebar>
		</>
	);
};

export default AddGenre;
